import React, {useContext} from 'react'
import {useStaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import {GlobalStateContext} from "../../../context/GlobalContextProvider"

const MargitInterview2022 = (state) => {
    state = useContext(GlobalStateContext);
    const data = useStaticQuery(graphql`
        query {
            pressMargitInterview: file(relativePath: { eq: "Team/scholl.jpg" }) {
                childImageSharp {
                    fluid(maxHeight: 500, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `)

    return (
        <div className={state.pressId}>
            <div className="box">
                <div className="image-container">
                    <a  href="https://alarm.wildau.biz/alarm_media/interview-2022-11-30.mp4" 
                        target="_blank" rel="noreferrer">
                    <Img fluid={data.pressMargitInterview.childImageSharp.fluid} className="image"/> 
                    </a>
                </div>
                <p>
                Interview -- Schutz vor Cyber-Attacken
                </p>
                <p className="subtitle" >
                    <a href="https://alarm.wildau.biz/alarm_media/interview-2022-11-30.mp4"
                        target="_blank" rel="noreferrer" 
                        aria-label="Blogartikel">
                        ab Minute 1:10 (1GB)
                    </a>
                </p>
            </div>
        </div>
    )
};

export default MargitInterview2022;